/**
 * Movimiento del sistema de cards de resultados. Vive suelto y no dentro del
 * componente para poder testear la regla sin un entorno de DOM: la suite del
 * frontend es de funciones puras a propósito (ver `jest.config.cjs`).
 */

/** Entrada de una card: opacity + translateY(6px). */
export const RESULT_ENTRY_DURATION_MS = 160;

/** La curva de la entrada (ease-out marcado: entra y frena). */
export const RESULT_ENTRY_EASING = 'cubic-bezier(.23,1,.32,1)';

/** Lo que se corre cada card respecto de la anterior. */
export const RESULT_ENTRY_STAGGER_MS = 40;

/**
 * Cuántas cards escalonan. Más allá de la sexta el escalonado ya no se lee
 * (están fuera de la pantalla) y solo retrasaría la lista.
 */
export const RESULT_ENTRY_STAGGERED_COUNT = 6;

/**
 * El retraso de entrada de la card en la posición `index`. Escalona solo las
 * primeras `RESULT_ENTRY_STAGGERED_COUNT`; de ahí en más el retraso se
 * mantiene en el de la última escalonada, así una búsqueda de 40 resultados
 * no tarda un segundo y medio en terminar de aparecer.
 *
 * Una posición inválida (negativa, fraccionaria, `NaN`, o ninguna) entra sin
 * retraso: el escalonado es un lujo visual y nunca puede dejar una card
 * invisible o con un `animation-delay` roto.
 */
export function resultEntryDelayMs(index?: number): number {
  if (typeof index !== 'number' || !Number.isInteger(index) || index <= 0) return 0;
  return Math.min(index, RESULT_ENTRY_STAGGERED_COUNT - 1) * RESULT_ENTRY_STAGGER_MS;
}
